var _defs, _circle, _circle2, _path, _path2, _circle3, _path3, _path4, _line, _circle4, _path5, _circle5, _circle6, _line2, _line3, _polyline, _ellipse, _ellipse2, _path6, _path7, _rect, _rect2, _circle7, _circle8, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#f85565;}.cls-15,.cls-2,.cls-7{fill:#fff;}.cls-2{opacity:0.2;}.cls-3{fill:#4bc190;}.cls-4,.cls-6{fill:#356cb6;}.cls-4{opacity:0.3;}.cls-5{fill:#fbc0aa;}.cls-10,.cls-11,.cls-16,.cls-8{fill:none;stroke-linecap:round;}.cls-11,.cls-8{stroke:#fbc0aa;}.cls-10,.cls-11,.cls-8{stroke-linejoin:round;}.cls-8{stroke-width:14px;}.cls-9{fill:#ffd8c9;}.cls-10,.cls-16{stroke:#515570;}.cls-10{stroke-width:1.89px;}.cls-10,.cls-15{opacity:0.4;}.cls-11{stroke-width:3px;}.cls-12{opacity:0.1;}.cls-13{fill:#393c54;}.cls-14{fill:#515570;}.cls-16{stroke-miterlimit:10;stroke-width:4px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64,
    cy: 64,
    r: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89,51.35l12.66,14.82A4,4,0,0,1,98.11,72H75.67l-4-23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89,51.35l12.66,14.82A4,4,0,0,1,98.11,72H75.67l-4-23Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 89.84,
    cy: 70.87,
    r: 7.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64,124a59.75,59.75,0,0,0,37.53-13.2l-2-5.53C98,101.5,93.68,99,88.89,99H39.11c-4.79,0-9.07,2.51-10.68,6.28l-2,5.53A59.75,59.75,0,0,0,64,124Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.26,101.86c0,5.66-4.6,9.25-10.26,9.25s-10.26-3.59-10.26-9.25,4.6-3.42,10.26-3.42S74.26,96.19,74.26,101.86Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 64,
    x2: 64,
    y1: 88.88,
    y2: 100.88
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 38.16,
    cy: 70.87,
    r: 7.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M64,98A26.78,26.78,0,0,1,37.21,71.19V61.57a26.79,26.79,0,0,1,53.58,0v9.62A26.78,26.78,0,0,1,64,98Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 64,
    cy: 27.38,
    r: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 64,
    cy: 27.38,
    r: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 74.12,
    x2: 83.21,
    y1: 64.84,
    y2: 64.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 53.88,
    x2: 44.79,
    y1: 64.84,
    y2: 64.6
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "64 70 64 75 66.36 79.03 61.63 79.03"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 51.15,
    cy: 78.72,
    rx: 4.34,
    ry: 2.82
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 76.85,
    cy: 78.72,
    rx: 4.34,
    ry: 2.82
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M71.55,84a1,1,0,0,1,.94,1.07,8.56,8.56,0,0,1-17,0A1,1,0,0,1,56.45,84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,90.91a8.52,8.52,0,0,0,10.08,0C68,89.16,66.17,89,64,89S60,89.16,59,90.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 2,
    width: 2,
    x: 62,
    y: 84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    height: 2,
    width: 2,
    x: 65,
    y: 84
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 76,
    cy: 70.87,
    r: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 52,
    cy: 70.87,
    r: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M91.49,60.12V59.4c0-14.95-11.71-27.61-26.66-28A27.51,27.51,0,0,0,36.51,58.82v1.33a2,2,0,0,0,2,2h7.38a6.23,6.23,0,0,0,5.35-3l2.52-4.19s13,0,13,0c4.4,4.34,10,7.18,16.21,7.18h6.44A2,2,0,0,0,91.49,60.12Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.92,57a2,2,0,0,0,2-2.15c-1.06-14.82-13-27-28-27.45-15.67-.47-28.68,12.13-29.8,27.46a2,2,0,0,0,2,2.14Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M74,57c.56,0,1-1,1-2.15-.52-14.82-3.29-27-10.57-27.45C56.84,26.93,48.54,39.53,48,54.86,48,56,48.41,57,49,57Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M70.67,52c0,5-18.07,5-18.07,0a9,9,0,0,1,18.07,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M66.08,47.92a6,6,0,0,0-4.45-2H51.94"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,52H75.5A2.5,2.5,0,0,1,78,54.5v0A2.5,2.5,0,0,1,75.5,57H48a1,1,0,0,1-1-1V53a1,1,0,0,1,1-1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48,52H75.5A2.5,2.5,0,0,1,78,54.5v0A2.5,2.5,0,0,1,75.5,57H48a1,1,0,0,1-1-1V53a1,1,0,0,1,1-1Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 74.67,
    cy: 54.5,
    r: 1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 70.67,
    cy: 54.5,
    r: 1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 66.67,
    cy: 54.5,
    r: 1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 62.67,
    cy: 54.5,
    r: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 58.67,
    cy: 54.5,
    r: 1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 54.67,
    cy: 54.5,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyIcon);
export default __webpack_public_path__ + "static/media/boy_icon.713934bca8577b51b46cfaf4ab361d69.svg";
export { ForwardRef as ReactComponent };